var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("b-loading", {
        attrs: {
          "is-full-page": _vm.isFullPage,
          active: _vm.isLoading,
          "can-cancel": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar sidebar-fixed bg-white",
          attrs: { id: "sidebarMenu" }
        },
        [
          _c("div", { staticClass: "sidebar-header" }, [
            _c("h5", [_vm._v("Search")]),
            _vm._v(" "),
            _c(
              "a",
              { attrs: { href: "", id: "sidebarMenuClose" } },
              [
                _c("feather", {
                  staticClass: "svg_overflow",
                  attrs: { type: "x" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sidebar-body" },
            [
              _vm.properties.uid
                ? _c(
                    "div",
                    _vm._l(_vm.inputSearchForms, function(form, i) {
                      return form.division === "C"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: form.id } }, [
                                _vm._v(_vm._s(form.name) + " "),
                                form.division === "C" && form.attr
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "tx-danger has-text-weight-semibold"
                                      },
                                      [_vm._v("*")]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.lazy",
                                    value: _vm.receptionData[form.id],
                                    expression: "receptionData[form.id]",
                                    modifiers: { lazy: true }
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "email",
                                  name: form.id,
                                  id: form.id,
                                  placeholder: form.name
                                },
                                domProps: { value: _vm.receptionData[form.id] },
                                on: {
                                  change: function($event) {
                                    return _vm.$set(
                                      _vm.receptionData,
                                      form.id,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        : _vm._e()
                    }),
                    0
                  )
                : _c(
                    "div",
                    _vm._l(_vm.inputSearchForms, function(form, i) {
                      return form.division === "C" && form.name != "Department"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            form.attr != "contractno"
                              ? _c("div", { staticClass: "form-group" }, [
                                  _c("label", { attrs: { for: form.id } }, [
                                    _vm._v(_vm._s(form.name) + " "),
                                    form.division === "C" && form.attr
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tx-danger has-text-weight-semibold"
                                          },
                                          [_vm._v("*")]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.lazy",
                                        value: _vm.receptionData[form.id],
                                        expression: "receptionData[form.id]",
                                        modifiers: { lazy: true }
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "email",
                                      name: form.id,
                                      id: form.id,
                                      placeholder: form.name
                                    },
                                    domProps: {
                                      value: _vm.receptionData[form.id]
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.receptionData,
                                          form.id,
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            form.attr === "contractno"
                              ? _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: form.id } }, [
                                      _vm._v(_vm._s(form.name) + " "),
                                      form.division === "C" && form.attr
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tx-danger has-text-weight-semibold"
                                            },
                                            [_vm._v("*")]
                                          )
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-field",
                                      [
                                        _c("b-input", {
                                          attrs: {
                                            type: "number",
                                            min: "0",
                                            max: "400000",
                                            name: form.id,
                                            id: form.id,
                                            placeholder: form.name
                                          },
                                          model: {
                                            value: _vm.receptionData[form.id],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.receptionData,
                                                form.id,
                                                $$v
                                              )
                                            },
                                            expression: "receptionData[form.id]"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    }),
                    0
                  ),
              _vm._v(" "),
              _vm._l(_vm.inputCompanyForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  i === 0
                    ? _c("li", { staticClass: "nav-label mg-b-10-f" }, [
                        _vm._v(" ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { attrs: { for: form.id } }, [
                        _vm._v(_vm._s(form.name)),
                        form.division === "C" && form.attr
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "tx-danger has-text-weight-semibold"
                              },
                              [_vm._v("*")]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-field",
                        [
                          _c(
                            "b-autocomplete",
                            {
                              ref: "companyName",
                              refInFor: true,
                              attrs: {
                                id: form.id,
                                data: _vm.filteredDataArray,
                                placeholder: form.name
                              },
                              on: {
                                select: function(option) {
                                  return (_vm.selected = option)
                                }
                              },
                              model: {
                                value: _vm.companyName,
                                callback: function($$v) {
                                  _vm.companyName = $$v
                                },
                                expression: "companyName"
                              }
                            },
                            [
                              _c("template", { slot: "empty" }, [
                                _vm._v("No results found")
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.checkboxSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: " d-block has-text-weight-semibold",
                          attrs: { for: "formGroupExampleInput" }
                        },
                        [_vm._v(_vm._s(form.name))]
                      ),
                      _vm._v(" "),
                      _vm._l(form.value, function(form1, i) {
                        return _c(
                          "div",
                          {
                            staticClass: "ml-2 custom-control custom-radio mb-1"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.receptionData[form.id],
                                  expression: "receptionData[form.id]"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: {
                                type: "radio",
                                id: form1.codeCode,
                                name: form.id
                              },
                              domProps: {
                                value: form1.codeCode,
                                checked:
                                  form1.codeCode == _vm.receptionData[form.id],
                                checked: _vm._q(
                                  _vm.receptionData[form.id],
                                  form1.codeCode
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.receptionData,
                                    form.id,
                                    form1.codeCode
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: form1.codeCode }
                              },
                              [_vm._v(_vm._s(form1.codeName))]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.dateSearchForms, function(form, i) {
                return _c("ul", { staticClass: "sidebar-nav" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "d-block has-text-weight-semibold",
                        attrs: { for: "formGroupExampleInput" }
                      },
                      [_vm._v(_vm._s(form.name))]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "mg-b-0 text-left" }, [
                      _vm._v(_vm._s(_vm.receptionData[form.id]))
                    ])
                  ])
                ])
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content content-components pd-b-0-f" }, [
        _c("div", { staticClass: "pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
          _c(
            "div",
            {
              staticClass:
                "d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
            },
            [
              _c("div", [
                _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                  _c(
                    "ol",
                    { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                    [
                      _c("li", { staticClass: "breadcrumb-item" }, [
                        _vm._v(_vm._s(this.mainName))
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v(_vm._s(this.subName))]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "breadcrumb-item active",
                          attrs: { "aria-current": "page" }
                        },
                        [_vm._v("Detail")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                    _vm._v(_vm._s(this.subName) + " Detail")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                      on: {
                        click: function($event) {
                          return _vm.confirmData()
                        }
                      }
                    },
                    [
                      _c("feather", {
                        staticClass: "wd-10 mg-r-5 svg_overflow",
                        attrs: { type: "folder" }
                      }),
                      _vm._v("Confirm")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                      on: {
                        click: function($event) {
                          return _vm.createData(true)
                        }
                      }
                    },
                    [
                      _c("feather", {
                        staticClass: "wd-10 mg-r-5 svg_overflow",
                        attrs: { type: "folder" }
                      }),
                      _vm._v("Save")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.properties.uid
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                          on: {
                            click: function($event) {
                              return _vm.deleteData()
                            }
                          }
                        },
                        [
                          _c("feather", {
                            staticClass: "wd-10 mg-r-5 svg_overflow",
                            attrs: { type: "delete" }
                          }),
                          _vm._v("delete")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                      on: {
                        click: function($event) {
                          return _vm.goPage()
                        }
                      }
                    },
                    [
                      _c("feather", {
                        staticClass: "wd-10 mg-r-5 svg_overflow",
                        attrs: { type: "file" }
                      }),
                      _vm._v("List")
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card col-lg-8 col-xl-7 mg-b-20 mg-lg-b-25" },
            [
              _c(
                "div",
                { staticClass: "d-none d-md-block tx-right-f mg-xs-y-15-f" },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 is-pulled-left",
                      attrs: {
                        href: "",
                        "data-toggle": "modal",
                        "data-animation": "effect-flip-horizontal"
                      },
                      on: { click: this.checkAll }
                    },
                    [
                      _c("feather", {
                        staticClass: "wd-10 mg-r-5 svg_overflow",
                        attrs: { type: "check" }
                      }),
                      _vm._v("Checked")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                      attrs: {
                        href: "#modal11",
                        "data-toggle": "modal",
                        "data-animation": "effect-flip-horizontal"
                      }
                    },
                    [
                      _c("feather", {
                        staticClass: "wd-10 mg-r-5 svg_overflow",
                        attrs: { type: "plus" }
                      }),
                      _vm._v("Add")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                      attrs: {
                        href: "",
                        "data-toggle": "modal",
                        "data-animation": "effect-flip-horizontal"
                      },
                      on: { click: this.sampleDelColumn }
                    },
                    [
                      _c("feather", {
                        staticClass: "wd-10 mg-r-5 svg_overflow",
                        attrs: { type: "minus" }
                      }),
                      _vm._v("Delete")
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("hot-table", {
                ref: "sheet",
                staticClass: "ht-hot-table",
                attrs: {
                  id: "sample-table",
                  settings: _vm.sheetSettings,
                  data: _vm.sampleData,
                  afterChange: _vm.changeData
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal11",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel11",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14" }, [
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary tx-13",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary tx-13",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: this.sampleAddColumn }
                    },
                    [_vm._v("Add")]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal14",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel14",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered chat-width",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14 chat-height" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [_c("Chat")], 1)
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h6",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel11" } },
        [_vm._v("Sample Create")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("p", { staticClass: "mg-b-0" }, [
        _vm._v("Please enter the number of samples to register.")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mg-b-0" }, [_vm._v(" ")]),
      _vm._v(" "),
      _c("p", { staticClass: "mg-b-0" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: { type: "number", min: "1", max: "100", id: "addNum" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h6",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel14" } },
        [_vm._v("Chat")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14cb76a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14cb76a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Contract/DetailForm.vue
// module id = null
// module chunks = 